import Header from '@/components/member/ui/header';
import { ReactComponent as ArrowLeft } from '@/assets/img/arrow_left_primary.svg';
import { isEmpty } from 'lodash';
import { useDispatch } from 'react-redux';
import {
  setMemberEditEntrance,
  setMemberPageState,
} from '@actions/member/memberAction';
import PropTypes from 'prop-types';

function MemberHeader({ children, title }) {
  const dispatch = useDispatch<any>();

  const handleMemberPageOpen = () => {
    dispatch(setMemberPageState(''));
    dispatch(setMemberEditEntrance(false));
  };

  return (
    <Header>
      <div style={{ width: '33%' }} onClick={handleMemberPageOpen}>
        <ArrowLeft style={{ marginLeft: '15px' }} />
      </div>

      <div
        className={`d-flex align-items-center justify-content-center fw-bold ${
          isEmpty(children) ? 'w-100' : ''
        }`}
        style={{ width: '66%', fontSize: '18px' }}
      >
        {title}
      </div>
      <div
        style={{ width: '33%' }}
        className="d-flex align-items-center justify-content-center"
      >
        {children}
      </div>
    </Header>
  );
}

MemberHeader.defaultProps = {
  children: <div />,
  title: '',
};

MemberHeader.propTypes = {
  children: PropTypes.element,
  title: PropTypes.string,
};

export default MemberHeader;
